import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import { apiActions } from "../../../../slices/api-slice";
import { ApiMetaShopOrderGet, MetaShopOrderGetResponse } from "../../../../api/front/meta/api-meta-shop-order";
import { ResponseBase } from "../../../../api/response-base";
import { RoutingPath } from "../../../../routes/routing-path";

type Props = {
  kijshopCd: string,
  shopOrderId: string,
}

export const usePreparation = (props: Props) => {
  const {
    kijshopCd,
    shopOrderId,
  } = props;
  const [isOneStop, setIsOneStop] = useState(false);
  const dispatch = useAppDispatch();
  
  const getMeta = useCallback(() => {
    dispatch(apiActions.run(
      new ApiMetaShopOrderGet({
        kijshopCd,
        shopOrderId,
      },
    ), {
      onSuccess: (res: ResponseBase<MetaShopOrderGetResponse>) => {
        setIsOneStop(!!res.body?.data?.cfOrderId)
    }}));
  }, [dispatch, kijshopCd, shopOrderId]);
  
  const preparationPath = useMemo(() => {
    if (!isOneStop) {
      return RoutingPath.cnv.ordersPreparation({ kijshopCd, shopOrderId });
    }
    return RoutingPath.cnv.oneStopOrdersPreparation({ kijshopCd, shopOrderId });
  }, [isOneStop, kijshopCd, shopOrderId]);
  
  useEffect(() => {
    getMeta();
  }, [kijshopCd, shopOrderId]);
  return {
    preparationPath,
  }
}